export default function handleStickyHeaderScroll(): void {

  // hederとmainの要素を取得
  const headerElement = document.querySelector('header') as HTMLElement | null;
  const mainElement = document.querySelector('main') as HTMLElement | null;

  // 見つからない場合は処理を終了
  if (!headerElement || !mainElement) return;

  // スクロール50px以上でheaderとmainにis-shrinkクラスを付与
  if (window.scrollY > 80) {
    headerElement?.classList.add('is-scrolled');
    mainElement?.classList.add('is-scrolled');
  } else {
    headerElement?.classList.remove('is-scrolled');
    mainElement?.classList.remove('is-scrolled');
  }
}